module.exports = __webpack_public_path__ + "static/media/medManager_02.8b9f4048.gif";